<template>
    <article class="hidden w-20 bg-white shadow-xl p-5 md:flex flex-col justify-between items-center">
        <router-link :to="{ name: 'chat'}">
            <img src="@/app/assets/img/logo.png" alt="Logo" class="w-8"/>
        </router-link>

        <div class="space-y-3">
            <router-link 
                    v-for="(menu, index) in menus" 
                    :key="index" 
                    :to="menu.router" 
                    class="block p-3 rounded-lg hover:bg-primary-50"
                    :class="{
                        'block p-3 rounded-lg hover:bg-secondary bg-secondary text-white': $route.name == menu.router.name
                    }">
                <Icon :icon="menu.icon" class="text-2xl m-auto"/>
            </router-link>
        </div>

        <div>
            <router-link :to="{ name: 'configuration'}" class="block p-3 rounded-lg hover:bg-primary-50" 
                    :class="{
                        'block p-3 rounded-lg hover:bg-secondary bg-secondary text-white': $route.name == 'configuration'
                    }">
                <Icon icon="uil:setting" class="text-2xl m-auto"/>
            </router-link>
        </div>
    </article>
</template>

<script setup>
import { ref } from 'vue';
import { Icon } from '@iconify/vue';

const menus = ref([{
    icon: 'meteor-icons:message',
    router: { name: 'chat'}
},
{
    icon: 'ci:folder',
    router: { name: 'contacts'}
}])
</script>